import React from "react";

const LangContext = React.createContext({
    locale: '',
    setLocale: () => {},
    t:'',
});

export default LangContext;